import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { LocalStorage } from '../local-storage/local-storage.service';
import { environment } from '../../../../environments/environment';
import { ThemeEnum } from './models/enums/theme.enum';
import { PrimeNG } from "primeng/config";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor(
    private readonly primeNg: PrimeNG,
    private readonly localStorage: LocalStorage,
  ) { }

  private readonly _theme: WritableSignal<ThemeEnum> = signal(ThemeEnum.LIGHT);

  public get theme(): Signal<ThemeEnum> {
    return this._theme;
  }

  public set theme(theme: ThemeEnum) {
    this.localStorage.setItem(environment.keys.theme, theme);
    this._theme.set(theme);

    this.loadTheme(theme);
  }

  public initialize(): void {
    const theme = this.localStorage.getItem<ThemeEnum>(environment.keys.theme);

    if (theme)
      this.theme = theme;
  }

  private loadTheme(theme?: ThemeEnum): void {
    const element = document.querySelector('html');

    if (theme && theme === ThemeEnum.DARK) {
      document.body.classList.add(ThemeEnum.DARK);
      element!.classList.add(ThemeEnum.DARK);
      return;
    }

    this.primeNg.theme.set({ darkModeSelector: false });
    element!.classList.remove(ThemeEnum.DARK);
    document.body.classList.remove(ThemeEnum.DARK);
  }

}
